import { Message } from '@byecode/ui'
import { DevicePreviewEnum } from '@lighthouse/core'
import type { ActionFlowNode, FlowNodeResultADT, NotificationActionConfig, NotificationActionConfigure } from '@lighthouse/shared'
import { generateVariableValue } from '@lighthouse/shared'
import { safeToString } from '@lighthouse/tools'
import { t } from 'i18next'

import type { ExecuteActionParams } from '../type'

export const handleNotificationStream = async (
    node: ActionFlowNode<NotificationActionConfigure>,
    params: ExecuteActionParams
): Promise<undefined | FlowNodeResultADT> => {
    const {
        data: { config }
    } = node

    if (!config) {
        throw new Error(t('configurationNotPerfect'))
    }

    handleNotification(config, params)

    return await Promise.resolve({
        type: 'record',
        success: true
    })
}

export const handleNotification = (config: NotificationActionConfig, params: ExecuteActionParams) => {
    const { notificationStatus = 'SUCCESS', notificationContent } = config
    const toastType = notificationStatus.toLocaleLowerCase() as 'info' | 'success' | 'error'

    const title = generateVariableValue({
        innerType: 'TEXT',
        jsonContent: notificationContent,
        extraParams: params,
        options: { format: true, useFileUrl: true }
    })

    Message[toastType]({
        title: safeToString(title)
    })

    return title
}
